import script from "./side-menu-sub-item.vue?vue&type=script&setup=true&lang=ts"
export * from "./side-menu-sub-item.vue?vue&type=script&setup=true&lang=ts"

import "./side-menu-sub-item.vue?vue&type=style&index=0&id=6ce109f7&lang=scss"

const __exports__ = script;

export default __exports__